import React from "react"
import { graphql } from "gatsby"
import Layout from "../../components/Layout/layout"
import ResultsTaxo from "../../components/ResultsTaxo/results-taxo"
import PropTypes from "prop-types"
import SEO from "../../components/seo"

//-----------------------QueryGraphql---------------------------//

export const query = graphql`
  query ($slugTerm: String!, $limit: Int!, $skip: Int!) {
    allNodeTeleformulaires(
      limit: $limit
      skip: $skip
      filter: {
        relationships: {
          field_taxonomie_teleformulaire: {
            elemMatch: { name: { eq: $slugTerm } }
          }
        }
      }
    ) {
      ...TaxoTeleform
    }
  }
`
//-----------------------QueryGraphql---------------------------//

//-----------------------Component---------------------------//

const TaxoTeleformulairesTemplate = ({ data, pageContext }) => {
  const teleformResults = data.allNodeTeleformulaires.edges
  const { slugTerm } = pageContext
  return (
    <Layout message="Résultats">
      <SEO
        title={slugTerm}
        description={
          "Dans cette page, vous découvrez une liste de téléformulaires regroupés par thématique, la thématique est la suivante : " +
          slugTerm
        }
      />
      <ResultsTaxo pageContext={pageContext} resultats={teleformResults} />
    </Layout>
  )
}

//-----------------------Component---------------------------//

//-----------------------Prop-Types---------------------------//

TaxoTeleformulairesTemplate.propTypes = {
  data: PropTypes.object.isRequired,
  pageContext: PropTypes.object,
}
//-----------------------Prop-Types---------------------------//

export default TaxoTeleformulairesTemplate
